import axiosInstance from "./apis";

export const getSalesVoucherNumber = async (payload) => {
  return await axiosInstance.post(`/sales/get-sales-voucher-no`,payload);
};

export const saveSales = async (payload) => {
  return await axiosInstance.post(`/sales/create-sales`, payload);
};

export const editSales = async (payload) => {
  return await axiosInstance.post(`/sales/edit-sales`, payload);
};

export const savePharmaSales = async (payload) => {
  return await axiosInstance.post(`/sales/create-patient-sales`, payload);
};

export const editPharmaSales = async (payload) => {
  return await axiosInstance.post(`/sales/edit-patient-sales`, payload);
};

export const getTagForSales = async (payload) => {
  return await axiosInstance.post(`/sales/get-tag-sales`, payload);
  
};

